export const defaultMapStyle = process.env.REACT_APP_DEFAULT_MAP_STYLE;
export const minZoom = {
    deals: 7,
    leads: 10,
    leaseComps: 9,
    saleComps: 9,
    favorites: 7,
    zoning: 13,
    zoningLabels: 15,
    landUse: 11,
    landUseLabels: 13,
    iosZoning: 11,
    parcels: 14,
    counties: 7,
    aadt: 14,
    opportunityZone: 4,
    rails: 8,
    pointsOfInterest: 9,
    recordedSales: 9,
    locations: 4,
};

export const maxZoom = {
    counties: 12,
}